module.exports = "/packs/images/shadow~5914bfe37fe329198bda36e9a1de6232.png";